import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-assessment-info-card',
  templateUrl: './assessment-info-card.component.html',
  styleUrls: ['./assessment-info-card.component.scss']
})
export class AssessmentInfoCardComponent implements OnInit {

  @Input() assessmentInfo: any;

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void { }


  getShortName(fullName) {
    return fullName?.split(' ').map(n => n[0]).join('');
  }
  // Our Terms now opens as a page in a new tab via routerLink in template

}
